{
    "unlockRewards": [
        {
            "transactionalStat": 0,
            "rewardObject": "Reward Coins",
            "prerequisite": 0,
            "highAmount": 1500,
            "rewardName": "CoinsInventoryFormat",
            "lowAmount": 250,
            "requirePrerequisite": false,
            "isCoinReward": true,
            "applyRewardToXP": false,
            "implemented": true
        },
        {
            "transactionalStat": 15,
            "rewardObject": "Reward Bombs",
            "prerequisite": 1,
            "highAmount": 6,
            "rewardName": "CoconutBombsInventoryFormat",
            "lowAmount": 2,
            "requirePrerequisite": true,
            "isCoinReward": false,
            "applyRewardToXP": false,
            "implemented": true
        },
        {
            "transactionalStat": 16,
            "rewardObject": "Reward Clock Mag",
            "prerequisite": 2,
            "highAmount": 6,
            "rewardName": "ClockMagnetsInventoryFormat",
            "lowAmount": 2,
            "requirePrerequisite": true,
            "isCoinReward": false,
            "applyRewardToXP": false,
            "implemented": false
        },
        {
            "transactionalStat": 17,
            "rewardObject": "Reward Skull Smasher",
            "prerequisite": 4,
            "highAmount": 6,
            "rewardName": "SkullMagnetsInventoryFormat",
            "lowAmount": 2,
            "requirePrerequisite": true,
            "isCoinReward": false,
            "applyRewardToXP": false,
            "implemented": false
        },
        {
            "transactionalStat": 18,
            "rewardObject": "Reward Nuke",
            "prerequisite": 10,
            "highAmount": 4,
            "rewardName": "TheNukeInventoryFormat",
            "lowAmount": 2,
            "requirePrerequisite": true,
            "isCoinReward": false,
            "applyRewardToXP": false,
            "implemented": false
        },
        {
            "transactionalStat": 19,
            "rewardObject": "Reward Fruit Smasher",
            "prerequisite": 5,
            "highAmount": 6,
            "rewardName": "FruitSmasherInventoryFormat",
            "lowAmount": 2,
            "requirePrerequisite": true,
            "isCoinReward": false,
            "applyRewardToXP": false,
            "implemented": true
        },
        {
            "transactionalStat": 0,
            "rewardObject": "Reward XP",
            "prerequisite": 0,
            "highAmount": 5000,
            "rewardName": "XPRewardFormat",
            "lowAmount": 1000,
            "requirePrerequisite": false,
            "isCoinReward": false,
            "applyRewardToXP": true,
            "implemented": true
        },
        {
            "transactionalStat": 49,
            "rewardObject": "Reward Barriers",
            "prerequisite": 48,
            "highAmount": 6,
            "rewardName": "BarrierInventoryFormat",
            "lowAmount": 2,
            "requirePrerequisite": true,
            "isCoinReward": false,
            "applyRewardToXP": false,
            "implemented": false
        }
    ],
    "malwearRewards": [
        {
            "transactionalStat": 26,
            "rewardName": "MalwearGirlyBow",
            "spriteName": "bow",
            "malWear": 8
        },
        {
            "transactionalStat": 28,
            "rewardName": "MalwearKarateHeadband",
            "spriteName": "karagte",
            "malWear": 10
        },
        {
            "transactionalStat": 36,
            "rewardName": "MalwearTennisHeadband",
            "spriteName": "tenis",
            "malWear": 18
        },
        {
            "transactionalStat": 29,
            "rewardName": "MalwearLennonGlasses",
            "spriteName": "lenon_glasses",
            "malWear": 11
        },
        {
            "transactionalStat": 57,
            "rewardName": "MalwearBasket",
            "spriteName": "basket",
            "malWear": 24
        },
        {
            "transactionalStat": 71,
            "rewardName": "MalwearNerdGlasses",
            "spriteName": "glasses",
            "malWear": 38
        }
    ]
}
